import React from 'react';
import { NavLink } from 'components/Navigation';
import { paths, features } from 'constants';

const NavLinks = () => (
  <ul className="jg-space-mn">
    <li className="navigation__li">
      <NavLink
        isActive={() => window.location.pathname.includes(paths.Personal)}
        path={paths.Personal}
        name="Personal details"
      />
    </li>
    <li className="navigation__li">
      <NavLink path={paths.Password} name="Change password" />
    </li>
    {features.donationHistory && (
      <li className="navigation__li">
        <NavLink path={paths.DonationHistory} name="Donation history" />
      </li>
    )}
    {features.recurringDonations && (
      <li className="navigation__li">
        <NavLink path={paths.MonthlyDonations} name="Monthly donations" />
      </li>
    )}
    <li className="navigation__li">
      <NavLink path={paths.PaymentMethods} name="Payment methods" />
    </li>
    <li className="navigation__li">
      <NavLink path={paths.Notifications} name="Preferences" />
    </li>
    <li className="navigation__li">
      <NavLink path={paths.Apps} name="Apps" />
    </li>
  </ul>
);

export default NavLinks;
